import { Box } from "@mui/material";
import { H1 } from "../components/Typography";

const GiftingTopBanner = () => {
  return (
    <Box
      sx={{
        borderRadius: 5,
        display: {
          md: "flex",
          xs: "none",
        },
        justifyContent: "space-between",
        alignItems: "center",
        background: "linear-gradient(90deg, #DD9401 0%, #FFD072 100%)",
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "row",
        },
      }}
    >
      <Box
        component="img"
        sx={{
          height: {
            xs: "60%",
            sm: "60%",
            md: "40%",
          },
          width: {
            xs: "60%",
            sm: "60%",
            md: "20%",
          },
        }}
        src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/leftGiftBanner.svg"
        alt="saas-dasboard-footer"
      />

      <Box
        justifyContent="center"
        textAlign="center"
        sx={{
          width: {
            xs: "80%",
            sm: "80%",
            md: "60%",
          },
          paddingY: {
            xs: 2,
            sm: 2,
            md: 5,
          },
        }}
      >
        <H1
          fontSize={24}
          fontWeight={600}
          sx={{
            textAlign: "center",
            fontFamily: "'Poppins', sans-serif",
          }}
          color="#ffffff"
        >
          Give a gift that grows over time with our digital gold and silver
          options
        </H1>
      </Box>
      <Box
        component="img"
        sx={{
          height: {
            xs: "60%",
            sm: "60%",
            md: "50%",
          },
          width: {
            xs: "60%",
            sm: "60%",
            md: "15%",
          },
          display: {
            xs: "none",
            md: "block",
          },
        }}
        src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/rightGiftBanner.svg"        alt="saas-dasboard-footer"
      />
    </Box>
  );
};

export default GiftingTopBanner;
